import React from 'react'
import MwInputText from './MwInputText'

import {PiPlusSquareLight,PiMinusSquareLight} from 'react-icons/pi'

const InputQty = ({label,disabled=false,value,onChange,onIncress,onDecress,custClassName,width='24',TYPE}) => {
    const resolvedWidth = (() => {
        if (typeof width === 'number') return `${width}px`;
        if (typeof width === 'string') {
            if (width.endsWith('%') || width.endsWith('px') || width.endsWith('rem')) return width;
            const numericValue = Number.parseFloat(width);
            if (Number.isFinite(numericValue)) return `${numericValue * 4}px`;
        }
        return '96px';
    })();

    return (
        <>
            { label && 
                <label className='text-xs px-1 text-slate-400  text-center' >{label}</label>}
            <div 
                className='flex justify-center items-center rounded'
                style={{ width: resolvedWidth, minWidth: resolvedWidth }}
            >
                {/* <PiPlusSquareLight 
                    onClick={ !disabled ? onIncress : ()=>{}}
                    className={`  px-1 h-8 rounded-s-lg border ${ disabled ? 'bg-slate-200 dark:bg-slate-700 text-slate-500' :'bg-white dark:bg-slate-700' } `} size={24}/>
                 */}
                <MwInputText 
                    // label={`${  label}`}
                    disabled = {disabled}
                    value={value} 
                    inputType={TYPE}
                    onChange={onChange}
                    classNameInput = {`border ${custClassName}`}  
                    
                    />
                {/* <PiMinusSquareLight
                    onClick={ !disabled ? onDecress : ()=>{}}
                    className={ `px-1 h-8 rounded-e-lg border ${ disabled ? 'bg-slate-200 dark:bg-slate-700 text-slate-500' :'bg-white dark:bg-slate-700' } `}
                    size={24}/> */}
            </div>
        </>
    )
}

export default InputQty
